<template>
    <div class="filter-inline">
        <md-field class="filter-field">
            <label class="field-label">Status:</label>
            <md-select id="status-select" v-model="filter.status">
                <md-option key="status-All" value="all">All</md-option>
                <md-option v-for="item in statusOptions" :key="`status-${item.value}`" :value="item.value">
                    {{ item.text }}
                </md-option>
            </md-select>
        </md-field>
        <md-field class="filter-field">
            <label class="field-label">Payment Source:</label>
            <md-select id="payment-select" v-model="filter.paymentSource">
                <md-option key="payment-All" value="all">All</md-option>
                <md-option v-for="item in paymentOptions" :key="`payment-${item.value}`" :value="item.value">
                    {{ item.text }}
                </md-option>
            </md-select>
        </md-field>
        <md-field class="filter-field">
            <label class="field-label">Product Type:</label>
            <md-select id="productType-select" v-model="filter.productType">
                <md-option key="productType-All" value="all">All</md-option>
                <md-option v-for="item in productTypeOptions" :key="`payment-${item.value}`" :value="item.value">
                    {{ item.text }}
                </md-option>
            </md-select>
        </md-field>
    </div>
</template>

<script>
export default {
    name: 'EntAgreementFilter',
    data() {
        return {
            statusOptions: [
                {
                    text: 'Paid',
                    value: 'paid'
                },
                {
                    text: 'Pending bidfin Payment',
                    value: 'pending_bidfin_payment'
                },
                {
                    text: 'Pending Client Approval',
                    value: 'pending_client_approval'
                },
                {
                    text: 'Pending',
                    value: 'pending'
                },
                {
                    text: 'Awaiting Payment',
                    value: 'awaiting_payment'
                },
                {
                    text: 'Cancelled',
                    value: 'cancelled'
                }
            ],
            paymentOptions: [
                {
                    text: 'Bidfin',
                    value: 'bidfin'
                },
                {
                    text: 'Credit Card',
                    value: 'credit_card'
                },
                {
                    text: 'License Created',
                    value: 'license_created'
                },
                {
                    text: 'On Account',
                    value: 'on_account'
                },
                {
                    text: 'Razorpay',
                    value: 'credit_card_razorpay'
                },
                {
                    text: 'Stripe (credit card)',
                    value: 'credit_card_stripe'
                },
                {
                    text: 'Stripe (On Account)',
                    value: 'on_account_stripe'
                }
            ],
            productTypeOptions: [
                {
                    text: 'Addon',
                    value: 'addon'
                },
                {
                    text: 'Enterprise',
                    value: 'enterprise'
                },
                {
                    text: 'Gps',
                    value: 'gps'
                },
                {
                    text: 'Premium',
                    value: 'premium'
                },
                {
                    text: 'Standard',
                    value: 'standard'
                }
            ],
            filter: {
                status: 'all',
                paymentSource: 'all',
                productType: 'all'
            }
        };
    },
    watch: {
        'filter.status': function(newVal) {
            this.raiseEvent();
        },
        'filter.paymentSource': function(newVal) {
            this.raiseEvent();
        },
        'filter.productType': function(newVal) {
            this.raiseEvent();
        }
    },
    methods: {
        async raiseEvent() {
            const args = {
                status: this.filter.status === 'all' ? null : this.filter.status,
                paymentSource: this.filter.paymentSource === 'all' ? null : this.filter.paymentSource,
                productType: this.filter.productType === 'all' ? null : this.filter.productType
            };
            this.$emit('onChanged', args);
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .filter-field {
    display: inline-block;
    width: 200px;
    margin-right: 20px;
}
</style>
